export const REGISTRATION_PHASE0_VALIDATED = false;
